<div class="not-found">
    <h1>Página não encontrada</h1>
</div>
